<template>
  <div class="contact-page">
    <div class="contact-shell">
      <section class="contact-intro">
        <p class="contact-eyebrow">Request a Consultation</p>
        <h1>See Fathom in Action</h1>
        <p>
          Learn how Fathom delivers modular, cost-effective underwater monitoring solutions to businesses and organizations around the world.
        </p>
        <img class="contact-jelly" src="@/assets/images/Jelly.png" alt="" loading="lazy" decoding="async">
      </section>

      <section class="contact-form-panel" aria-label="Consultation request form">
        <form ref="form" class="form" novalidate @submit.prevent="send">
          <b-field label="Name" label-for="contact-name">
            <b-input id="contact-name" v-model="name" name="name" autocomplete="name" required></b-input>
          </b-field>

          <b-field label="Email" label-for="contact-email">
            <b-input id="contact-email" v-model="email" name="email" type="email" autocomplete="email" required></b-input>
          </b-field>

          <b-field label="Phone" label-for="contact-phone">
            <b-input id="contact-phone" v-model="phone" name="phone" type="tel" autocomplete="tel"></b-input>
          </b-field>

          <b-field label="Title" label-for="contact-title">
            <b-input id="contact-title" v-model="title" name="title" autocomplete="organization-title"></b-input>
          </b-field>

          <b-field label="Company/Organization" label-for="contact-organization">
            <b-input id="contact-organization" v-model="org" name="org" autocomplete="organization"></b-input>
          </b-field>

          <b-field label="Sector" label-for="contact-sector">
            <b-select id="contact-sector" v-model="sector" name="sector" placeholder="Select a sector" expanded>
              <option value="Industry">Industrial</option>
              <option value="Research">Research</option>
            </b-select>
          </b-field>

          <b-field label="Message" label-for="contact-message">
            <b-input id="contact-message" v-model="message" name="message" type="textarea" required></b-input>
          </b-field>

          <b-button native-type="submit" :loading="isSending" :disabled="isSending">
            Submit
          </b-button>

          <p
            v-if="statusMessage"
            class="form-status"
            :class="{ 'is-error': statusType === 'error' }"
            role="status"
            aria-live="polite"
          >
            {{ statusMessage }}
          </p>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import emailjs from '@emailjs/browser'
import { init } from '@emailjs/browser'

init('user_oE6ffZm4i2t3L0xfQ8CXh')

export default {
  name: 'Demo',
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      title: '',
      org: '',
      sector: '',
      message: '',
      isSending: false,
      statusMessage: '',
      statusType: '',
    }
  },
  methods: {
    send() {
      if (!this.$refs.form.checkValidity()) {
        this.statusMessage = 'Please complete the required fields.'
        this.statusType = 'error'
        this.$refs.form.reportValidity()
        return
      }

      const templateParams = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        title: this.title,
        org: this.org,
        sector: this.sector,
        message: this.message,
      }

      this.isSending = true
      this.statusMessage = ''
      this.statusType = ''

      emailjs.send('fathom_website', 'template_trgn8jz', templateParams)
        .then(() => {
          this.statusMessage = 'Message sent!'
          this.statusType = 'success'
          this.$buefy.toast.open({
            message: 'Message sent!',
            type: 'is-success',
          })
          this.resetForm()
        }, (error) => {
          this.statusMessage = String(error)
          this.statusType = 'error'
          this.$buefy.toast.open({
            message: error,
            type: 'is-danger',
          })
        })
        .finally(() => {
          this.isSending = false
        })
    },
    resetForm() {
      this.name = ''
      this.email = ''
      this.phone = ''
      this.title = ''
      this.org = ''
      this.sector = ''
      this.message = ''
    },
  },
}
</script>
